import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const CatalogTitleHeading = ({ headingTitle, total }) => (
	<h1 className={styles.CatalogTitleHeading} data-cy="catalogTitleHeading">
		{headingTitle}{' '}
		<span className={styles.CatalogTitleHeading__ItemsCount}>{total}</span>
	</h1>
);

CatalogTitleHeading.propTypes = {
	headingTitle: PropTypes.string.isRequired,
	total: PropTypes.number
};

export default CatalogTitleHeading;
